/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, IconButton, TablePagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function PessoaList({ refresh, onEdit, onPessoaDeleted, filterNome, filterCnpj, filterCpf, filterRg }) {
  const { user } = useAuth();
  const [pessoas, setPessoas] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const fetchPessoas = () => {
    let apiUrl = `/pessoas?page=${page}&limit=${rowsPerPage}`;
    if (filterNome) apiUrl += `&nome=${filterNome}`;
    if (filterCnpj) apiUrl += `&cnpj=${filterCnpj}`;
    if (filterCpf) apiUrl += `&cpf=${filterCpf}`;
    if (filterRg) apiUrl += `&rg=${filterRg}`;

    api.get(apiUrl)
      .then((response) => {
        setPessoas(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => {
        console.error('Erro ao buscar pessoas:', error);
      });
  };

  useEffect(() => {
    fetchPessoas();
  }, [refresh, page, rowsPerPage, filterNome, filterCnpj, filterCpf, filterRg]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar esta pessoa?')) return;
    try {
      await api.delete(`/pessoas/${id}`);
      console.log('Pessoa deletada com sucesso!');
      onPessoaDeleted();
      fetchPessoas();
    } catch (error) {
      console.error('Erro ao deletar pessoa:', error);
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="pessoas table">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              {user?.tipo_usuario === 'admin' && <TableCell>Empresa ID</TableCell>}
              <TableCell>Nome</TableCell>
              <TableCell>CPF</TableCell>
              <TableCell>CNPJ</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pessoas.map((pessoa) => (
              <TableRow key={pessoa.id} hover>
                <TableCell>{pessoa.id}</TableCell>
                {user?.tipo_usuario === 'admin' && <TableCell>{pessoa.empresa_id}</TableCell>}
                <TableCell>{pessoa.nome}</TableCell>
                <TableCell>{pessoa.cpf || 'N/A'}</TableCell>
                <TableCell>{pessoa.cnpj || 'N/A'}</TableCell>
                <TableCell>
                  <IconButton aria-label="edit" onClick={() => onEdit(pessoa)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(pessoa.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(parseInt(event.target.value, 10));
          setPage(0);
        }}
        labelRowsPerPage="Linhas por p\u00E1gina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default PessoaList;
